import {useFetchData} from 'hooks/api/useFetchData'
import {CustomEmployeeFieldGroup} from 'types/api/settings/employeeFieldGroups/customEmployeeFieldGroup'

export const useFetchCustomEmployeeFieldGroups = (clientId: string) => {
  const path = `/api/clients/${clientId}/custom_employee_field_groups`
  return useFetchData<CustomEmployeeFieldGroup[]>(path, [], {})
}
